module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_3_1.19349093.jpeg";